import { graphql } from "relay-runtime"

export const chUpdateProgressNoteEpisodeOfCareMutation = graphql`
  mutation chUpdateProgressNoteEpisodeOfCareMutation(
    $input: Ch_updateProgressNoteEpisodeOfCareInput!
    $addConnections: [ID!]!
    $removedConnections: [ID!]!
  ) {
    updateProgressNoteEpisodeOfCare: ch_updateProgressNoteEpisodeOfCare(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      updateProgressNoteEpisodeOfCareOutput: ch_UpdateProgressNoteEpisodeOfCareOutput {
        progressNote @prependNode(connections: $addConnections, edgeTypeName: "ch_ProgressNoteEdge") {
          id @deleteEdge(connections: $removedConnections)
          ...chProgressNoteFragment @relay(mask: false)
          ...chProgressNoteFragment
        }
        currentEpisodeOfCare {
          id
          updatedAt
        }
        oldEpisodeOfCare {
          id
          updatedAt
        }
      }
    }
  }
`
